import type { IconNode } from '../types';

/**
 * @name credit-card-plus
 * @description Lucide SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTYgMTdoNiIgLz4KICA8cGF0aCBkPSJNMTkgMTR2NiIgLz4KICA8cGF0aCBkPSJNMjIgMTBIMiIgLz4KICA8cGF0aCBkPSJNMjIgMTEuMzU0VjdhMiAyIDAgMDAtMi0ySDRhMiAyIDAgMDAtMiAydjEwYTIgMiAwIDAwMiAyaDguNTM2IiAvPgo8L3N2Zz4K) - https://lucide.dev/icons/credit-card-plus
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const CreditCardPlus: IconNode = [
  ['path', { d: 'M16 17h6' }],
  ['path', { d: 'M19 14v6' }],
  ['path', { d: 'M22 10H2' }],
  ['path', { d: 'M22 11.354V7a2 2 0 00-2-2H4a2 2 0 00-2 2v10a2 2 0 002 2h8.536' }],
];

export default CreditCardPlus;
